import { rexRoundedField } from '@/utils/mapping'
import initialState from './initialState'

const mutations = {
  setCollection(state, { results, notFoundText }) {
    if (!results.length) {
      results.push({
        label: null,
        collection: [
          {
            name: notFoundText,
            slug: null
          }
        ]
      })
    }

    state.collection = results.map((item, index) => rexRoundedField.autocomplete(item, index))
  },
  updateIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  setInitialState() {
    this.state.autocomplete = {
      ...initialState()
    }
  }
}

export default mutations